import qs from "query-string"
import { http } from "../common/post"
import urls from "../common/urls"
import captureException from "../common/error"
import { formatRecommendationResponse } from "../common/common"


const DashboardSource = {
  getOffices: owner => http(`${urls.offices}?owner=${owner}`, "GET"),
  getPlanProviders: office =>
    http(`${urls.planProviders}?office=${office}`, "GET"),
  getPlans: (office, planProvider) =>
    http(`${urls.plans}?office=${office}&plan_provider=${planProvider}`, "GET"),
  getPlanInformation: () => http(urls.plan_information, "GET", undefined, true),
  submitPlanInformation: (office, plan, plan_holder) =>
    http(urls.plan_information, "POST", { office, plan, plan_holder }),
  updatePlanInformation: (office, plan, plan_holder) =>
    http(urls.update_plan_information, "POST", { office, plan, plan_holder }),
  getDashboardRecommendations: query =>
    http(
      `${urls.getDashboardRecommendations}?${qs.stringify(query)}`,
      "GET",
      {}
    ).then(data => {
      // Transform response for consumption by components
      data.recommendations.sections = data.recommendations.sections.map(sect => {
        let transformed = Object.assign({}, sect)
        transformed.recommendations = transformed.recommendations.filter(rec => typeof rec !== "string").map(rec => {
          return formatRecommendationResponse(rec)
        })
        return transformed
      })

      return data
    }).catch(captureException),
  trackUserDashboardView: marketplaceToken => http(urls.trackUserDashboardView, "POST", { marketplaceToken }),
}

export { DashboardSource as default }



// WEBPACK FOOTER //
// ./assets/dashboard/Source.js